"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ThemeProvider from "./theme-provider";
import { NuqsAdapter } from "nuqs/adapters/next";
import { AuthProvider } from "@/domains/auth/auth-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { CompanyProvider } from "@/shared/hooks/use-company";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { setAppRouter } from "@/shared/utils/navigate";

const queryClient = new QueryClient();

function RouterInitializer() {
  const router = useRouter();
  useEffect(() => {
    setAppRouter(router);
  }, [router]);
  return null;
}

export default function CoreProvider({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterInitializer />
      <NuqsAdapter>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
          <CompanyProvider>
              <AuthProvider>
                <TooltipProvider>{children}</TooltipProvider>
              </AuthProvider>
          </CompanyProvider>
        </ThemeProvider>
      </NuqsAdapter>
    </QueryClientProvider>
  );
}
